var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14425",
    "data-name": "Group 14425",
    transform: "translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14421",
    "data-name": "Group 14421",
    transform: "translate(40.432 47.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_11",
    "data-name": "Subtraction 11",
    d: "M23.768,33.273c-.037,0-3.762,0-7.894-.124-2.428-.072-4.518-.171-6.21-.294A27.829,27.829,0,0,1,5.2,32.282,5.966,5.966,0,0,1,.991,28.077a36.361,36.361,0,0,1-.867-7.11C0,18.6,0,16.655,0,16.635S0,14.674.124,12.3a39.958,39.958,0,0,1,.867-7.11A5.972,5.972,0,0,1,5.2.989,27.805,27.805,0,0,1,9.664.417C11.357.294,13.446.2,15.875.124,20.006,0,23.731,0,23.768,0s3.764,0,7.9.124c2.429.072,4.518.171,6.211.294a27.722,27.722,0,0,1,4.465.572,5.968,5.968,0,0,1,4.205,4.205,36.361,36.361,0,0,1,.867,7.11c.122,2.37.124,4.312.124,4.331s0,1.961-.124,4.331a39.958,39.958,0,0,1-.867,7.11,5.967,5.967,0,0,1-4.205,4.205,27.712,27.712,0,0,1-4.465.573c-1.692.123-3.782.222-6.211.294C27.533,33.271,23.805,33.273,23.768,33.273ZM19.019,9.5h0V23.767l12.349-7.131L19.019,9.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17858",
    "data-name": "Rectangle 17858",
    width: 64,
    height: 64,
    transform: "translate(32 32)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.a41046ba0604e6f8065f68e3fad93ce6.svg";
export { ForwardRef as ReactComponent };